/* =====================================================================
   BodyStop.in - FAQ topic buttons for concern collection pages
   File: assets/bodystop-concern.js

   How the page HTML should look:

     <div class="bs-faq">
       <p class="bs-faq-topic">Sugar Levels</p>
       <details>...</details>
       <details>...</details>
       <p class="bs-faq-topic">Body Effects</p>
       <details>...</details>
     </div>

   Each <p class="bs-faq-topic"> starts a topic, and every question below
   it belongs to that topic until the next label. The script turns the
   labels into a row of buttons (All | Sugar Levels | Body Effects ...).
   A tap shows only that topic's questions. Tapping the active button
   again, or tapping All, shows every question.

   Buttons only appear when the block has 8 or more questions and at
   least 2 topics. Otherwise, or if this file fails to load, the labels
   stay as small group headings and every question stays visible.
   ===================================================================== */
(function () {
  'use strict';

  var MIN_QUESTIONS = 8;
  var ALL_LABEL = 'All';

  function setup(box) {
    if (box.getAttribute('data-bs-ready')) return;

    var topics = [];
    var questions = [];
    var current = null;

    Array.prototype.forEach.call(box.children, function (el) {
      if (el.classList.contains('bs-faq-topic')) {
        var name = el.textContent.replace(/\s+/g, ' ').trim();
        current = name ? { name: name, items: [] } : null;
        if (current) topics.push(current);
      } else if (el.tagName === 'DETAILS') {
        questions.push(el);
        if (current) current.items.push(el);
      }
    });

    topics = topics.filter(function (t) { return t.items.length > 0; });
    if (questions.length < MIN_QUESTIONS || topics.length < 2) return;

    box.setAttribute('data-bs-ready', '1');

    var bar = document.createElement('div');
    bar.className = 'bs-faq-topics';
    bar.setAttribute('role', 'group');
    bar.setAttribute('aria-label', 'Show questions by topic');

    var buttons = [];

    function show(index) {
      var picked = buttons[index].items; // null means All
      buttons.forEach(function (b, i) {
        b.el.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      });
      questions.forEach(function (q) {
        q.hidden = picked !== null && picked.indexOf(q) === -1;
      });
    }

    function addButton(label, items) {
      var index = buttons.length;
      var el = document.createElement('button');
      el.type = 'button';
      el.textContent = label;
      el.setAttribute('aria-pressed', 'false');
      el.addEventListener('click', function () {
        var alreadyOn = el.getAttribute('aria-pressed') === 'true';
        show(alreadyOn ? 0 : index);
      });
      buttons.push({ el: el, items: items });
      bar.appendChild(el);
    }

    addButton(ALL_LABEL, null);
    topics.forEach(function (t) { addButton(t.name, t.items); });

    box.insertBefore(bar, box.firstChild);
    show(0);
  }

  function init(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('.bs-faq'), setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // re-run when a section is reloaded in the Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();